var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferralReferIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 85,
    viewBox: "0 0 96 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.6931L40.203 1.48038C42.7433 -0.493461 46.2944 -0.493461 48.8346 1.48038L89.0377 32.6931V85H0V32.6931Z",
    fill: "#41D17E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7367 4.96582H10.3008V80.3771H78.7367V4.96582Z",
    fill: "#FAFAFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70 14H18V18H70V14Z",
    fill: "#DBDBDB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70 26H18V30H70V26Z",
    fill: "#DBDBDB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57 33H18V37H57V33Z",
    fill: "#DBDBDB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5163 58.8621L0 32.7242V85L44.5163 58.8621Z",
    fill: "#406DB6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5156 58.8621L89.0371 32.7242V85L44.5156 58.8621Z",
    fill: "#406DB6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.203 53.7873L0 85H89.0377L48.8346 53.7873C46.2944 51.8134 42.7433 51.8134 40.203 53.7873Z",
    fill: "#B1C1D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralReferIcon);
export default __webpack_public_path__ + "static/media/referral_refer_icon.31eaa0d30c3b33c73056f9cfd16d9612.svg";
export { ForwardRef as ReactComponent };